import { useEffect, useState } from 'react'

import { useAdServerConfigurationContext } from '../../ad-server'

/**
 * Hook to check if an ad banner is available (based on metadata presence).
 * This avoids rendering empty ad placeholders when no banner is available.
 *
 * @param bannerTags - Array of banner identifiers
 * @param dimensions - Banner dimensions (width and height)
 * @returns boolean - True if a banner with metadata is available, false otherwise
 */

export const useSearchPageIsAdBannerAvailable = (
  bannerTags: string[],
  dimensions: {
    height: number
    width: number
  },
): boolean => {
  const { getBanner, initBanners } = useAdServerConfigurationContext()
  const [isAvailable, setIsAvailable] = useState<boolean>(false)

  const bannerId = bannerTags.toString()

  useEffect(() => {
    const bannerData = getBanner({
      height: dimensions.height,
      id: bannerId,
      width: dimensions.width,
    })

    if (!bannerData) {
      initBanners([
        {
          height: dimensions.height,
          id: bannerId,
          width: dimensions.width,
        },
      ])

      return
    }

    setIsAvailable(Boolean(bannerData.metadata))
  }, [bannerId, dimensions, getBanner, initBanners])

  return isAvailable
}
